import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {Input, makeInputModel} from '../common/controls/input'
import {companyLoginStore} from './company-login-store'

export const CompanyLoginRegister = observer(() => {
  const bem = Util.bemFrom('company-login')

  const {error, wait} = companyLoginStore.state

  const back = () => companyLoginStore.setScreen('main')
  const username = makeInputModel()
  const email = makeInputModel()
  const pass = makeInputModel()
  const ok = async () => {
    companyLoginStore.setWait(true)
    const res = await companyLoginStore.register(
      email.get(),
      username.get(),
      pass.get()
    )
    if (res.error) {
      companyLoginStore.setError(res.error)
    } else {
      companyLoginStore.setScreen('sent-email')
    }
  }
  const cleanError = () => {
    if (error) {
      companyLoginStore.setError('')
    }
  }
  if (wait) {
    return (
      <div className={bem('panel')}>
        <div className={bem('loading')} />
      </div>
    )
  }

  return (
    <div className={bem('panel')}>
      <Input
        type="text"
        className={bem('input-email')}
        placeholder={Lang.msg.email}
        model={email}
        onChange={cleanError}
        onEnter={ok}
      />
      <Input
        type="text"
        className={bem('input-name')}
        placeholder={Lang.msg.name}
        model={username}
        onChange={cleanError}
        onEnter={ok}
      />
      <Input
        type="password"
        className={bem('input-pass')}
        placeholder={Lang.msg.password}
        model={pass}
        onChange={cleanError}
        onEnter={ok}
      />
      <div className={bem('ok')} onClick={ok}>
        {Lang.msg.registration}
      </div>
      <div className={bem('back')} onClick={back}>
        {Lang.msg.back}
      </div>
      {!!error && <div className={bem('error')}>{error}</div>}
    </div>
  )
})
